/** Filtros de listados en sessionStorage — se eliminan al cerrar sesión. */

export const INSPECTIONS_LIST_STATE_KEY = "inspectionsListState";
export const INSPECTION_GENERAL_LIST_STATE_KEY = "inspectionGeneralListState";

const LIST_PAGE_STATE_KEYS = [
  INSPECTIONS_LIST_STATE_KEY,
  INSPECTION_GENERAL_LIST_STATE_KEY,
];

export function clearListPageFilters() {
  LIST_PAGE_STATE_KEYS.forEach((key) => {
    try {
      sessionStorage.removeItem(key);
    } catch {
      // ignore quota / private mode
    }
  });
}
